import { getModelById } from './models';

export interface LlmUsage {
  inputTokens: number;
  outputTokens: number;
  costUsd?: number; // реальная стоимость генерации из ответа OpenRouter, если доступна
}

// Наценка над себестоимостью провайдера (реальный costUsd или per-1k ставки модели).
export const CHAT_MARKUP = 1.4;

// Фоллбэк-ставки (USD/1k, ДО наценки) для моделей вне allowlist.
const FALLBACK_IN = 0.003;
const FALLBACK_OUT = 0.012;

function round6(n: number): number {
  return Math.round(n * 1e6) / 1e6;
}

/**
 * Возвращает РЕАЛЬНУЮ стоимость LLM-хода в USD (дробное число, БЕЗ округления
 * вверх и БЕЗ минимума в 1) — user.tokens это USD-баланс (1 token = $1), так
 * что списание должно быть в тех же единицах, а не в искусственных "кредитах".
 */
export function computeChatCostUsd(usage: LlmUsage, modelId: string): number {
  const anyUsage = (usage.inputTokens ?? 0) + (usage.outputTokens ?? 0) > 0 || (usage.costUsd ?? 0) > 0;
  if (!anyUsage) return 0;

  if (typeof usage.costUsd === 'number' && Number.isFinite(usage.costUsd) && usage.costUsd > 0) {
    return round6(usage.costUsd * CHAT_MARKUP);
  }

  const model = getModelById(modelId);
  const inRate = model?.usdPer1kInput ?? FALLBACK_IN;
  const outRate = model?.usdPer1kOutput ?? FALLBACK_OUT;
  const usd = ((usage.inputTokens ?? 0) / 1000) * inRate + ((usage.outputTokens ?? 0) / 1000) * outRate;
  const cost = usd * CHAT_MARKUP;
  return Number.isFinite(cost) ? round6(Math.max(0, cost)) : 0;
}
